<template>
  <div class="space-y-8">
    <div>
      <ProductAddAction :acc-product-id="accProductId" @product-added="onProductAdded" />
    </div>
    <div>
      <ProductList ref="productList" :acc-product-id="accProductId" @change="$emit('refresh')" />
    </div>
  </div>
</template>

<script>
import ProductAddAction from './ProductAddAction.vue';
import ProductList from './ProductList.vue';

export default {
  components: { ProductList, ProductAddAction },
  props: {
    accProductId: {
      type: String,
      required: true,
    },
  },
  methods: {
    onProductAdded() {
      this.$refs.productList.refreshList();
    },
  },
};
</script>
